export enum ExportStatus {
  Queued = 'Queued',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
}

export interface ExportJob {
  id: string;

  title: string;

  description?: string;

  status: ExportStatus;

  progress: number;

  createdAt: Date;

  completedAt?: Date;

  downloadUrl?: string;

  errorMessage?: string;

  fileSize?: string;

  requestedBy?: string;
}

export enum BackgroundTaskStatus {
  Queued = 'Queued',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
}

export interface BackgroundTask {
  JobId: string;
  Title: string;
  Description?: string;

  Status: BackgroundTaskStatus;

  Progress: number;

  CreatedAt?: string;

  CompletedAt?: string;

  FileLink?: string;

  FileName?: string;

  ReportName?: string;

  FileSize?: string;

  RecordsCount?: number;

  FileExtension?: string;

  payload?: string;

  Program?: string;

  DateRange?: string;

  EndDate?: string;

  StartDate?: string;

  Error?: string;

  callback?: any;
}

export interface BackgroundTaskPaged {
  Downloads: Array<BackgroundTask>;
  Total: number;
}

export const BackgroundTaskStatusConfig = {
  // Queued: {
  //   icon: 'far fa-clock',          // Or 'fa-solid fa-list-ol'
  //   color: '#6c757d',                   // Muted Gray
  // },
  Pending: {
    icon: 'far fa-clock', // Or 'fa-solid fa-list-ol'
    color: '#6c757d', // Muted Gray
  },
  Processing: {
    icon: 'far fa-spinner fa-spin', // Added 'fa-spin' for a loading effect
    color: '#505459', // Blue
  },
  Completed: {
    icon: 'far fa-check-double', // Checkmark
    color: '#198754', // Green
  },
  Failed: {
    icon: 'far fa-circle-xmark', // X Mark
    color: '#dc3545', // Red
  },
};

export const FileTypeConfig = {
  // Excel / Spreadsheets
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    icon: 'fa-solid fa-file-excel',
    color: '#107c41', // Excel Green
    tailwindColor: 'text-green-600',
  },
  'application/vnd.ms-excel': {
    icon: 'fa-solid fa-file-excel',
    color: '#107c41',
    tailwindColor: 'text-green-600',
  },

  'text/csv': {
    icon: 'fa-solid fa-file-excel',
    color: '#107c41',
    tailwindColor: 'text-green-600',
  },
  // Word / Documents
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    icon: 'fa-solid fa-file-word',
    color: '#2b579a', // Word Blue
    tailwindColor: 'text-blue-600',
  },
  'application/msword': {
    icon: 'fa-solid fa-file-word',
    color: '#2b579a',
    tailwindColor: 'text-blue-600',
  },

  // PowerPoint / Presentations
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    icon: 'fa-solid fa-file-powerpoint',
    color: '#d24726', // PowerPoint Orange/Red
    tailwindColor: 'text-orange-600',
  },

  // PDF
  'application/pdf': {
    icon: 'fa-solid fa-file-pdf',
    color: '#b30b00', // PDF Red
    tailwindColor: 'text-red-600',
  },

  // Images
  'image/jpeg': { icon: 'fa-solid fa-file-image', color: '#e05300', tailwindColor: 'text-orange-500' },
  'image/png': { icon: 'fa-solid fa-file-image', color: '#e05300', tailwindColor: 'text-orange-500' },
  'image/gif': { icon: 'fa-solid fa-file-image', color: '#e05300', tailwindColor: 'text-orange-500' },

  // Audio / Video
  'video/mp4': { icon: 'fa-solid fa-file-video', color: '#7c4dff', tailwindColor: 'text-purple-500' },
  'audio/mpeg': { icon: 'fa-solid fa-file-audio', color: '#00bcd4', tailwindColor: 'text-cyan-500' },

  // Archives / Zips
  'application/zip': { icon: 'fa-solid fa-file-zipper', color: '#fbc02d', tailwindColor: 'text-yellow-600' },
  'application/x-7z-compressed': {
    icon: 'fa-solid fa-file-zipper',
    color: '#fbc02d',
    tailwindColor: 'text-yellow-600',
  },

  // Code / Plain Text
  'text/plain': { icon: 'fa-solid fa-file-lines', color: '#607d8b', tailwindColor: 'text-slate-500' },
  'text/html': { icon: 'fa-solid fa-file-code', color: '#3f51b5', tailwindColor: 'text-indigo-500' },
  'application/json': { icon: 'fa-solid fa-file-code', color: '#3f51b5', tailwindColor: 'text-indigo-500' },

  // Generic Default Fallback
  default: {
    icon: 'fa-solid fa-file',
    color: '#6c757d',
    tailwindColor: 'text-gray-500',
  },
};
